import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { api } from '../lib/api';
import { Reveal } from './Reveal';

export default function UpcomingEventsSection() {
    const [events, setEvents] = useState(null);

    useEffect(() => {
        api.get('/events')
            .then((r) => setEvents(r.data.slice(0, 4)))
            .catch(() => setEvents([]));
    }, []);

    return (
        <section data-testid="events-section" className="py-24 sm:py-32 border-t border-line">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <Reveal className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-bronze flex items-center gap-3">
                            <span className="inline-block w-10 h-px bg-bronze" />
                            On the Ground
                        </p>
                        <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-cream">
                            Upcoming <span className="text-bronze">event activations.</span>
                        </h2>
                    </div>
                    <Link
                        to="/events"
                        data-testid="events-view-all-link"
                        className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-cream border border-line px-6 py-3 rounded-full hover:border-bronze transition-colors duration-500"
                    >
                        All Events
                        <ArrowUpRight size={13} className="text-bronze group-hover:rotate-45 transition-transform duration-300" />
                    </Link>
                </Reveal>

                <div className="mt-12 border-t border-line">
                    {events === null
                        ? Array.from({ length: 4 }).map((_, i) => (
                              <div key={i} className="h-24 border-b border-line animate-pulse bg-surface/30" />
                          ))
                        : events.map((e, i) => (
                              <motion.div
                                  key={e.id}
                                  data-testid="event-card"
                                  initial={{ opacity: 0, y: 24 }}
                                  whileInView={{ opacity: 1, y: 0 }}
                                  viewport={{ once: true }}
                                  transition={{ duration: 0.7, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
                                  className="group grid grid-cols-1 sm:grid-cols-12 gap-3 sm:gap-6 items-center py-7 border-b border-line hover:bg-surface/40 transition-colors duration-500 px-2 sm:px-4"
                              >
                                  <span className="sm:col-span-2 font-mono text-[11px] uppercase tracking-[0.2em] text-bronze">
                                      {e.date_label}
                                  </span>
                                  <h3 className="sm:col-span-5 font-serif text-xl sm:text-2xl text-cream group-hover:italic transition-all duration-300">
                                      {e.title}
                                  </h3>
                                  <span className="sm:col-span-3 inline-flex items-center gap-2 text-sm text-fog">
                                      <MapPin size={13} className="text-bronze shrink-0" />
                                      {e.location}
                                  </span>
                                  <span className="sm:col-span-2 font-mono text-[10px] uppercase tracking-[0.2em] text-fog sm:text-right">
                                      {e.category}
                                  </span>
                              </motion.div>
                          ))}
                </div>
            </div>
        </section>
    );
}
